import { CollectionList, Collection } from './styles'

CollectionList.Collection = Collection

export default CollectionList
